(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-bottom-description"] && !Shopify.designMode) return;
  try {
    
    const content = document.getElementById('collection-description--content');
    const button = document.getElementById('read-more');
    const limitContainer = document.getElementById('collectio--short-description');
    const limit = parseInt(limitContainer.getAttribute("data-limit"));
    
    console.log("limit", limit);
    
    let isTruncated = true;
    const contentData = content.innerText;

    if (content.innerText.length <= limit) {
        isTruncated = false;
    }
    if (isTruncated) {
    content.innerText = content.innerText.substring(0, limit).trim() + '...';
    }
    button.addEventListener('click', function() {
        content.classList.toggle('show');
        console.log("contentData", contentData);
        if (content.classList.contains('show')) {
            content.innerText = contentData;
            button.innerText = 'read less';
        } else {
            if (isTruncated) {
            content.innerText = content.innerText.substring(0, limit).trim() + '...';
            }
            button.innerText = 'read more';
        }
    });

  } catch(e) { console.error(e); }
})();
})();
